import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import BtnContent from '../../../components/buttons/BtnContent';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import Error from '../../../components/errors/Error';
import EditorForm from '../../../components/Inputs/formInput/EditorForm';
import InputForm from '../../../components/Inputs/formInput/InputForm';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
//SLICES
import { createContractThunk, getContractThunk, updateContractThunk, initialStateContract } from '../../../store/slices/catalogs/contracts.slice';
import { deleteClausuleThunk, initialStateQuestion, } from '../../../store/slices/catalogs/questions.slice';

const ContractForm = () => {
    const { t } = useTranslation();
    let { contract_id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { setValue, register, handleSubmit, formState: { errors } } = useForm();
    const { item, message, error } = useSelector(state => state.contracts);
    const [text, setText] = useState("");
    const [preguntas, setPreguntas] = useState([{ pregunta: '' }]);
    const isLoading = useSelector(state => state.isLoadingSlice);
    const questionState = useSelector(state => state.questions);

    useEffect(() => {
        if (contract_id) {
            dispatch(getContractThunk(contract_id));
        }
        return () => {
            dispatch(initialStateContract());
        };
    }, []);

    useEffect(() => {
        setValue('name', item?.name)
        setText(item.content);
        setPreguntas(
            item.clauses?.map(pregunta => ({
                id: pregunta.id,
                pregunta: pregunta.text
            })) || []
        );
    }, [item, setValue]);

    if (questionState.message === "Registro eliminado correctamente") {
        dispatch(getContractThunk(contract_id));
        dispatch(initialStateQuestion());
    }

    const onSubmit = (data) => {
        data.content = text
        data.clauses = preguntas;
        if (contract_id) {
            dispatch(updateContractThunk(contract_id, data));
        } else {
            dispatch(createContractThunk(data));
        }
    };

    if (message === "Registro creado correctamente " || message === "Registro actualizado correctamente ") {
        navigate(`/panel/contracts`);
    }

    const handleChange = (content) => {
        setText(content);
    };

    const handleAgregarPregunta = () => {
        setPreguntas([...preguntas, { id: '', pregunta: '' }]);
    };

    const handleEliminarPregunta = (index) => {
        const nuevasPreguntas = [...preguntas];
        nuevasPreguntas.splice(index, 1);
        setPreguntas(nuevasPreguntas);
    };

    const handleCambiarPregunta = (index, event) => {
        const nuevasPreguntas = [...preguntas];
        nuevasPreguntas[index].pregunta = event;
        setPreguntas(nuevasPreguntas);
    };

    const handleDeleteQuestion = (id) => {
        dispatch(deleteClausuleThunk(id));
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-[96%] mt-5 ml-5 ">
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={contract_id ? "Editar contrato" : "Nuevo contrato"} />
                    <div className='h-[90%]'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    spam={true}
                                    label={t("Nombre de contrato")}
                                    input="input"
                                    type="text"
                                    cols={1}
                                    register={register("name", { required: true })}
                                    errors={errors.name && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                            </div>
                            <div className='w-full'>
                                <EditorForm
                                    id={"text_one"}
                                    label={"Texto"}
                                    spam={true}
                                    cols={1}
                                    onChange={handleChange}
                                    initialValue={text}
                                />
                            </div>
                            <div>
                                {preguntas.map((pregunta, index) => (
                                    <div className='w-full flex flex-col' key={pregunta.id || index}>

                                        <EditorForm
                                            id={"text_one"}
                                            label={`Clausula ${index + 1}`}
                                            //spam={true}
                                            cols={1}
                                            onChange={(event) => handleCambiarPregunta(index, event)}
                                            placeholder={`Pregunta ${index + 1}`}
                                            initialValue={pregunta.pregunta}
                                        />
                                        <button
                                            type="button"
                                            className='bg-red-300/40 hover:bg-red-300 text-[14px] font-semibold transition-all gap-1 p-1 active:scale-95 rounded-full flex justify-center items-center w-30 h-8'
                                            onClick={() => pregunta.id ? handleDeleteQuestion(pregunta.id) : handleEliminarPregunta(index)}>
                                            <FaTrashAlt /> Eliminar Clausula
                                        </button>
                                    </div>
                                ))}
                                <div className='p-2 justify-center w-full flex my-3'>
                                    <button
                                        type="button"
                                        className='hover:bg-green-300/40 text-[15px] font-semibold transition-all gap-1 p-1 active:scale-95 rounded-full flex justify-center items-center w-30 h-8'
                                        onClick={handleAgregarPregunta}>
                                        <FaPlus /> Agregar clausula
                                    </button>
                                </div>
                            </div>
                            <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-orange-500 mt-8">
                                <BtnContent type="submit">{t("save_button")}</BtnContent>
                                <BtnContent cancel={true} to={`/panel/contracts`}>{t("canceled_button")}</BtnContent>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default ContractForm;